<template>
  <div>    
    <!-- componente para notificaciones -->
    <notifier-comp></notifier-comp>
    
    <!-- componente cabecera  -->
    <header-menu></header-menu>
    
    <!--  componente logo de la canina -->
    <logo></logo>
   
    <!-- menu principal -->
    <menu></menu>  
    
    <!-- Titulo frontal de la página  -->
    <page-title></page-title>
   
   <!-- vista central del router -->
    <transition name="fade">
      <router-view></router-view>
    </transition>
    
    <!--  componente footer -->
    <Footer></Footer>
    
    <!--  componente copyright -->
    <copyright></copyright>

  </div>
</template>

<script>
// @ is an alias to /src
import notifierComp from '@/components/layouts/Notifier.vue'
import HeaderMenu from '@/components/layouts/Header.vue'
import Logo from '@/components/layouts/Logo.vue'
import PageTitle from '@/components/layouts/Pagetitle.vue'
import Footer from '@/components/layouts/Footer.vue'
import Copyright from '@/components/layouts/Copyright.vue'

export default {
  name: 'home',
  components: {
    notifierComp,
    HeaderMenu,
    Logo,    
    PageTitle,    
    Footer, 
    Copyright
  }
}

</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.btn-w {
  min-width: 100px !important;
}
</style>
